__turbopack_context__.v({
  "accountSection": "NewHeader-module__4g7Q3G__accountSection",
  "algSearch": "NewHeader-module__4g7Q3G__algSearch",
  "header-button-container": "NewHeader-module__4g7Q3G__header-button-container",
  "header-right": "NewHeader-module__4g7Q3G__header-right",
  "invisible": "NewHeader-module__4g7Q3G__invisible",
  "logo": "NewHeader-module__4g7Q3G__logo",
  "logoCentered": "NewHeader-module__4g7Q3G__logoCentered",
  "logoHideMenu": "NewHeader-module__4g7Q3G__logoHideMenu",
  "logoutButton": "NewHeader-module__4g7Q3G__logoutButton",
  "menu": "NewHeader-module__4g7Q3G__menu",
  "menuCenterLogo": "NewHeader-module__4g7Q3G__menuCenterLogo",
  "menuJustifyContent": "NewHeader-module__4g7Q3G__menuJustifyContent",
  "new-header": "NewHeader-module__4g7Q3G__new-header",
  "new-header-margin-bottom": "NewHeader-module__4g7Q3G__new-header-margin-bottom",
  "offcanvasAccountIcon": "NewHeader-module__4g7Q3G__offcanvasAccountIcon",
  "offcanvasAccountLink": "NewHeader-module__4g7Q3G__offcanvasAccountLink",
  "searchBarRow": "NewHeader-module__4g7Q3G__searchBarRow",
  "searchIcon": "NewHeader-module__4g7Q3G__searchIcon",
  "searchIconColor": "NewHeader-module__4g7Q3G__searchIconColor",
  "signin": "NewHeader-module__4g7Q3G__signin",
  "subscribe": "NewHeader-module__4g7Q3G__subscribe",
  "tablet-account": "NewHeader-module__4g7Q3G__tablet-account",
  "visible": "NewHeader-module__4g7Q3G__visible",
});
